export enum ResidentialApplicationType {
  SINGLE_APPLICANT = "SINGLE_APPLICANT",
  JOINT_APPLICANT = "JOINT_APPLICANT",
}
